"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
exports.__esModule = true;
exports.createReactiveNodeViews = void 0;
var prosemirror_model_1 = require("prosemirror-model");
var reactiveNodeView = function (store, delegateView) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = __read(args), node = _a[0], restArgs = _a.slice(1);
        var possiblyReactedNode = store.getReactedCopy(node) || node;
        if (delegateView) {
            var delegate = delegateView.apply(void 0, __spread([possiblyReactedNode], restArgs));
            var update = delegate.update;
            var boundUpdate_1 = update && update.bind(delegate);
            Object.assign(delegate, {
                update: function (node, decorations) {
                    if (typeof boundUpdate_1 === "function") {
                        var latestReactiveCopy = store.getReactedCopy(node) || node;
                        return boundUpdate_1(latestReactiveCopy, decorations);
                    }
                    return false;
                }
            });
            return delegate;
        }
        var outputSpec = node.type.spec.toDOM(possiblyReactedNode);
        var _b = prosemirror_model_1.DOMSerializer.renderSpec(document, outputSpec), dom = _b.dom, contentDOM = _b.contentDOM;
        return {
            dom: dom,
            contentDOM: contentDOM,
            update: function () { return false; }
        };
    };
};
var collectNodeViews = function (view) {
    var result = {};
    view.someProp("nodeViews", function (obj) {
        for (var prop in obj) {
            if (!Object.prototype.hasOwnProperty.call(result, prop)) {
                result[prop] = obj[prop];
            }
        }
    });
    return result;
};
exports.createReactiveNodeViews = function (view, schema, store) {
    var reactiveViews = {};
    var existingViews = collectNodeViews(view);
    Object.values(schema.nodes).forEach(function (nodeType) {
        var name = nodeType.name, spec = nodeType.spec;
        if (spec.reactive) {
            var delegateView = existingViews[name];
            reactiveViews[name] = reactiveNodeView(store, delegateView);
        }
    });
    return reactiveViews;
};
